import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminReportService {

  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  getReports() {
    return this.http.get<any>(environment.url + '/MG/ReportRecipient/GetListReportRecipient', {
      headers: this.headers.set('Authorization',
        sessionStorage.getItem('t_admin'))
    })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  createReport(data) {
    return this.http.post<any>(environment.url + '/MG/ReportRecipient/CreateReportRecipient', data, {
      headers: this.headers.set('Authorization',
        sessionStorage.getItem('t_admin'))
    })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  updateReport(data) {
    return this.http.post<any>(environment.url + '/MG/ReportRecipient/UpdateReportRecipient', data, {
      headers: this.headers.set('Authorization',
        sessionStorage.getItem('t_admin'))
    })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  deleteReport(data) {
    let params = new HttpParams().set('idReportRecipient', data);
    return this.http.get<any>(environment.url + '/MG/ReportRecipient/DeleteReportRecipient',
      {
        headers: this.headers.set('Authorization', sessionStorage.getItem('t_admin')),
        params: params
      }
    )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
